<span [ngClass]="{'p-input-icon-right': updating }">
  <i class="pi pi-spin pi-spinner" *ngIf="updating"></i>
  <input 
    pInputText 
    type="text"
    class="trailer-number-input"
    (change)="updateTrailerNumber()"
    [formControl]="formControl" 
    [attr.aria-label]="'Set trailer ' + trailer.id + '\'s trailer number'"
  />
  <error-block [field]="formControl" [messages]="{
      required: 'Trailer # is required.',
      maxlength: 'Trailer # is too long.',
      duplicateDetected: 'Trailer # matches non-departed trailer.'
    }"
  ></error-block>
</span>
